import { render } from "./ckeditorModal.vue?vue&type=template&id=58e78749&scoped=true"
import script from "./ckeditorModal.vue?vue&type=script&lang=js"
export * from "./ckeditorModal.vue?vue&type=script&lang=js"

import "./ckeditorModal.vue?vue&type=style&index=0&id=58e78749&lang=css"
import "./ckeditorModal.vue?vue&type=style&index=1&id=58e78749&scoped=true&lang=css"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e78749"]])

export default __exports__